import React from 'react';
import moment from 'moment';

import Button from '../../../common/Button';

const TableItem = (props) => {
  const { item, handleFetchDecryption, loading, isLastItem, even, showRowArr, setShowRowArr } =
    props;

  const showDiff = showRowArr.includes(item.id) && item.diff !== undefined;

  const getSourceBadge = (type) => {
    if (type === 'USER') {
      return <div className="badge badge-grey">Пользователь</div>;
    }
    if (type === 'SYSTEM') {
      return <div className="badge badge-blue">Система</div>;
    }
    return <div className="badge badge-grey">{type}</div>;
  };

  const handleGetDecryption = () => {
    if (showDiff) {
      setShowRowArr((state) => state.filter((row) => row !== item.id));
      return;
    }
    handleFetchDecryption();
  };

  return (
    <>
      {!isLastItem ? (
        <>
          <tr className={even ? 'even' : null}>
            <td className="td-date">
              <div>
                {item.eventDate ? moment(item.eventDate).format('LL').replace(/ г.$/gm, '') : '-'}
              </div>
              <div className="light">
                {item.eventDate ? moment(item.eventDate).format('HH:mm:ss') : '-'}
              </div>
            </td>
            <td className="td-user">{item.userLogin}</td>
            <td className="td-source">{getSourceBadge(item.changeSource)}</td>
            <td>{item.description}</td>
            <td className="td-btn">
              {!isLastItem ? (
                <Button
                  type="button"
                  text={loading === item.id ? '' : 'Подробнее'}
                  classType="btn-link"
                  className="ml-2"
                  onClick={handleGetDecryption}
                  loading={loading === item.id}
                  disabled={loading === item.id}
                  icon={showDiff ? 'fe-chevron-up' : 'fe-chevron-down'}
                />
              ) : null}
            </td>
          </tr>
          {showDiff && !isLastItem ? (
            <tr className={even ? 'more-row even' : 'more-row'}>
              <td></td>
              <td colSpan={3}>
                <div>
                  <h5>Подробности изменений:</h5>
                  <p>{item.diff ? item.diff.replace(/[\\]/g, '') : 'Нет изменений'}</p>
                </div>
              </td>
              <td></td>
            </tr>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default TableItem;
